import { useState } from "react"
import dateComponent from "../../components/dateComponent"
import Vista from "../../components/Vista"
import TableCustom from "../../components/TableCustom"
import { useMessages } from "../../hooks/useMessages"
import { useHistory } from "react-router-dom"
import { useModal } from "../../hooks/useModal"

const busquedaDefault = {
  marca: "",
  fechaInicio: dateComponent.getFirstDayOfYear(),
  fechaFinal: dateComponent.getActualDay()
}

const Marca = ({ onClick, onKeyDown, ...props }) => {
  const [busqueda, setBusqueda] = useState({ ...busquedaDefault })
  const { setMessages } = useMessages()
  const [loadingButton, setLoadingButton] = useState(false)
  const history = useHistory()
  const [modalData, setModalData] = useState([])
  const { setContainerModal, setOpen } = useModal()

  //   const openModalHerramientas = async (idHerramienta) => {
  //     let isMounted = true

  //     try {
  //       const res = await servo.get(
  //         `herramientas-prestadas?idHerramienta=${idHerramienta}&expand=usuario,herramienta`
  //       )

  //       console.log("Respuesta de la API:", res)

  //       if (!isMounted) return // Evita actualizar si el componente se desmontó

  //       const validDataList = Array.isArray(res?.cuerpo?.resultado)
  //         ? res.cuerpo.resultado
  //         : []

  //       if (validDataList.length === 0) {
  //         setMessages({
  //           type: "warning",
  //           text: "No hay registros de préstamos para esta herramienta."
  //         })
  //         return
  //       }

  //       const sanitizedData = validDataList.map((item) => ({
  //         fechaPrestamo: item.fechaPrestamo ? String(item.fechaPrestamo) : "",
  //         fechaDevolucion: item.fechaDevolucion
  //           ? String(item.fechaDevolucion)
  //           : "Pendiente",
  //         usuario: item.usuario?.nombreCompleto || "Desconocido",
  //         cantidad: item.cantidad || 0,
  //         operacion: item.operacion || "N/A"
  //       }))

  //       if (isMounted) {
  //         setModalData(sanitizedData)

  //         const modalContent = (
  //           <div>
  //             <h2>Historial de Préstamos/Devoluciones</h2>
  //             <table style={{ width: "100%", borderCollapse: "collapse" }}>
  //               <thead>
  //                 <tr style={{ backgroundColor: "#157CC1", color: "#FFFFFF" }}>
  //                   <th style={{ padding: "10px" }}>Fecha Préstamo</th>
  //                   <th style={{ padding: "10px" }}>Fecha Devolución</th>
  //                   <th style={{ padding: "10px" }}>Usuario</th>
  //                   <th style={{ padding: "10px" }}>Cantidad</th>
  //                   <th style={{ padding: "10px" }}>Operación</th>
  //                 </tr>
  //               </thead>
  //               <tbody>
  //                 {sanitizedData.map((e, i) => (
  //                   <tr
  //                     key={i}
  //                     style={{
  //                       backgroundColor: i % 2 === 0 ? "#FFFFFF" : "#D9D9D9"
  //                     }}
  //                   >
  //                     <td style={{ padding: "10px", textAlign: "center" }}>
  //                       {e.fechaPrestamo || "N/A"}
  //                     </td>
  //                     <td style={{ padding: "10px", textAlign: "center" }}>
  //                       {e.fechaDevolucion || "Pendiente"}
  //                     </td>
  //                     <td style={{ padding: "10px", textAlign: "center" }}>
  //                       {e.usuario}
  //                     </td>
  //                     <td style={{ padding: "10px", textAlign: "center" }}>
  //                       {e.cantidad}
  //                     </td>
  //                     <td style={{ padding: "10px", textAlign: "center" }}>
  //                       {e.operacion}
  //                     </td>
  //                   </tr>
  //                 ))}
  //               </tbody>
  //             </table>
  //           </div>
  //         )

  //         setContainerModal(modalContent)
  //         setOpen(true)
  //       }
  //     } catch (error) {
  //       console.error("Error al obtener el historial:", error)
  //       if (isMounted) {
  //         setMessages({
  //           type: "error",
  //           text: "Error al obtener la información de la herramienta"
  //         })
  //       }
  //     }

  //     return () => {
  //       isMounted = false
  //     }
  //   }

  const dataTable = {
    id: {
      nombre: "ID",
      content: (e) => {
        return e.idMarca
      }
    },
    marca: {
      nombre: "Marca",
      content: (e) => {
        return e.marca
      }
    }
  }

  const dataPdf = {
    id: {
      nombre: "ID",
      content: (e) => {
        return e.idMarca
      }
    },
    marca: {
      nombre: "Marca",
      content: (e) => {
        return e.marca
      }
    }
  }

  return (
    <Vista>
      <TableCustom
        tipo={"idMarca"}
        busqueda={busqueda}
        setBusqueda={setBusqueda}
        dataTable={dataTable}
        dataPdf={dataPdf}
        fechaInicio={busqueda.fechaInicio}
        fechaFinal={busqueda.fechaFinal}
        // buscador={[
        //   <Grid
        //     item
        //     xs={10}
        //     sm={8}
        //     sx={{ marginRight: "10px", height: "41px" }}
        //     key={1}
        //   >
        //     <Input
        //       value={busqueda?.nombre}
        //       placeholder={"Nombre de la Herramienta"}
        //       typeInput={"onlyInput"}
        //       nombreBusqueda="nombre"
        //       onChange={(e) =>
        //         setBusqueda({ ...busqueda, nombre: e.target.value })
        //       }
        //     />
        //   </Grid>
        // ]}
        expand=""
        permisoCheck={"marcas"}
        nombreBusqueda={"marca"}
      />
    </Vista>
  )
}

export default Marca
